export default __webpack_public_path__ + "static/media/people-card.bg.7bc926c0.svg";